interface Props {
  [key: string]: any
}

function SparklesIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 24 24" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M9.93743 15.4998C9.84815 15.1537 9.66777 14.8379 9.41505 14.5851C9.16232 14.3324 8.8465 14.152 8.50043 14.0628L2.36543 12.4808C2.26076 12.4511 2.16864 12.388 2.10304 12.3012C2.03744 12.2144 2.00195 12.1086 2.00195 11.9998C2.00195 11.891 2.03744 11.7851 2.10304 11.6983C2.16864 11.6115 2.26076 11.5485 2.36543 11.5188L8.50043 9.93576C8.84638 9.84657 9.16212 9.66633 9.41483 9.4138C9.66754 9.16127 9.84799 8.84565 9.93743 8.49976L11.5194 2.36476C11.5488 2.25968 11.6118 2.1671 11.6987 2.10116C11.7857 2.03521 11.8918 1.99951 12.0009 1.99951C12.11 1.99951 12.2162 2.03521 12.3031 2.10116C12.39 2.1671 12.453 2.25968 12.4824 2.36476L14.0634 8.49976C14.1527 8.84583 14.3331 9.16166 14.5858 9.41438C14.8385 9.6671 15.1544 9.84748 15.5004 9.93676L21.6354 11.5178C21.7409 11.5469 21.834 11.6098 21.9003 11.6968C21.9666 11.7839 22.0025 11.8903 22.0025 11.9998C22.0025 12.1092 21.9666 12.2156 21.9003 12.3027C21.834 12.3898 21.7409 12.4527 21.6354 12.4818L15.5004 14.0628C15.1544 14.152 14.8385 14.3324 14.5858 14.5851C14.3331 14.8379 14.1527 15.1537 14.0634 15.4998L12.4814 21.6348C12.452 21.7398 12.389 21.8324 12.3021 21.8984C12.2152 21.9643 12.109 22 11.9999 22C11.8908 22 11.7847 21.9643 11.6977 21.8984C11.6108 21.8324 11.5478 21.7398 11.5184 21.6348L9.93743 15.4998Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M20 3V7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M22 5H18"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M4 17V19"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M5 18H3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default SparklesIcon
